import { createTheme, responsiveFontSizes } from '@mui/material/styles';

// Central theme configuration, shared between web and React Native
const theme = responsiveFontSizes(
  createTheme({
    palette: {
      mode: 'light',
      primary:   { main: '#ef233c' },
      secondary: { main: '#1e40af' },
      warning:   { main: '#f9c74f' },
      info:      { main: '#008000' },
      background: {
        default:   '#ffffff',
        paper:     '#f9fafb',
      },
      text: {
        primary:   '#1f2937',
        secondary: '#6b7280',
      },
    },
    typography: {
      fontFamily: 'Inter, sans-serif',
      h1: { fontFamily: 'Poppins, sans-serif', fontWeight: 700 },
      h2: { fontFamily: 'Poppins, sans-serif', fontWeight: 600 },
      h3: { fontFamily: 'Poppins, sans-serif', fontWeight: 600 },
      h4: { fontFamily: 'Poppins, sans-serif', fontWeight: 600 },
      h5: { fontFamily: 'Poppins, sans-serif', fontWeight: 600 },
      h6: { fontFamily: 'Poppins, sans-serif', fontWeight: 600 },
      body1: { fontFamily: 'Inter, sans-serif' },
      body2: { fontFamily: 'Inter, sans-serif' },
      caption: { fontFamily: 'Roboto, sans-serif' },
      button: { letterSpacing: '0.1em' },
    },
  components: {
    MuiButton: {
      styleOverrides: {
        // Inherit color for buttons using color="inherit"
        textInherit: ({ theme }) => ({
          color: theme.palette.text.primary,
        }),
      },
      variants: [
        {
          props: { variant: 'text' },
          style: ({ theme }) => ({
            color: theme.palette.text.primary,
          }),
        },
        {
          props: { variant: 'outlined' },
          style: ({ theme }) => ({
            color: theme.palette.text.primary,
          }),
        },
      ],
    },
    MuiIconButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.grey[100],
          borderRadius: '9999px',
          padding: theme.spacing(1),
          '&:hover': {
            backgroundColor: theme.palette.grey[200],
          },
        }),
        // Inherit color variant
        colorInherit: ({ theme }) => ({
          color: theme.palette.text.primary,
        }),
      },
    },
    MuiBottomNavigationAction: {
      styleOverrides: {
        root: ({ theme }) => ({
          // use darker grey for unselected state
          color: theme.palette.text.primary,
          '&.Mui-selected': {
            color: theme.palette.primary.main,
          },
        }),
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          // Hover uses lighter accent, selected uses main accent
          '&:hover': {
            backgroundColor: theme.palette.warning.light,
          },
          '&.Mui-selected': {
            backgroundColor: theme.palette.warning.main,
          },
          '&.Mui-selected:hover': {
            backgroundColor: theme.palette.warning.main,
          },
        }),
      },
    },
    MuiTab: {
      styleOverrides: {
        // Increase letter spacing on tab labels for a more squared look
        root: {
          letterSpacing: '0.1em',
        },
      },
    },
  },
  })
);

export default theme;